module.exports = __webpack_public_path__ + "media/images/libra-7b654290451dd725e21c88c7440b9fea.jpg";